export function getTotalValue(price: number | undefined, qtyVal: number) {
  if (typeof price === 'undefined' || isNaN(Number(price))) return null;

  const total = +price * qtyVal;
  return formatPrice(total);
}

/*
 @deprecated, use formatMoney moving forward
 */
export function formatPrice(
  price: string | number | undefined,
  decimalCount = 2,
) {
  if (typeof price === 'undefined' || isNaN(Number(price))) return null;

  let priceNum = price;
  if (typeof price === 'string') {
    priceNum = parseInt(price, 10);
  }

  return Number(priceNum).toLocaleString('en-US', {
    minimumFractionDigits: decimalCount,
    maximumFractionDigits: decimalCount,
  });
}

export function removeCentsFromAmount(formattedPrice: string): string {
  if (formattedPrice.endsWith('.00')) {
    return formattedPrice.replace('.00', '');
  } else {
    return formattedPrice;
  }
}

export function convertPriceToFloat(price: string) {
  if (!price) return;
  return parseFloat(price.replace(/[^\d.-]/g, ''));
}

export function convertCentsToDollars(cents: number | undefined) {
  if (cents == null || isNaN(cents)) {
    return NaN;
  }

  return cents / 100;
}

export function convertDollarsToCents(dollars: number | undefined) {
  if (dollars == null || isNaN(dollars)) {
    return NaN;
  }

  return Math.round(dollars * 100);
}

/**
 * Converts a price amount string to cents (integer)
 * This is useful for converting GraphQL API price strings to the AJAX cart format
 * @param amount - Price as string (e.g., "29.99")
 * @returns Price in cents (e.g., 2999), or 0 if the amount is invalid
 */
export function convertStringAmountToCents(amount: string): number {
  const parsed = parseFloat(amount);
  const cents = convertDollarsToCents(parsed);
  return Number.isNaN(cents) ? 0 : cents;
}
